import React, { useState } from "react";
import { SimpleDialog } from "../../components/dialogs/SimpleDialog";
import { TextField } from "@mui/material";
import {
  PropertyPhotoCategory,
  PropertyPhotoCategoryTranslations,
} from "common/types/common.types";

interface PropertyPhotoCategoryDialogProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  category: PropertyPhotoCategory;
  initialDescription?: string;
  onSubmit: (category: PropertyPhotoCategory, description: string) => void;
}

export const PropertyPhotoCategoryDialog: React.FC<
  PropertyPhotoCategoryDialogProps
> = ({ open, onClose, isLoading, category, initialDescription, onSubmit }) => {
  const [description, setDescription] = useState(initialDescription ?? "");
  return (
    <SimpleDialog
      title={PropertyPhotoCategoryTranslations[category] ?? "Kita"}
      open={open}
    isLoading={isLoading}
      onClose={onClose}
      buttonDisabled={!description || description === initialDescription}
      onSubmit={() => onSubmit(category, description)}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ marginTop: "20px" }}>Aprašymas</div>
        <TextField
          multiline
          rows={10}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </SimpleDialog>
  );
};
